import React from 'react'
import { GeckoComponentPath, GeckoHorizontalWeld } from 'types'

import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from './procedural/SurfaceLineFeature3D'

/**
 * A component used to render a single horizontal weld on a component's surface
 * @param model             The asset model for this horizontal weld
 * @constructor
 */
export const HorizontalWeldFeature3D: React.FC<{
  model: GeckoHorizontalWeld
}> = ({ model }) => {
  const path = React.useMemo(() => {
    return GeckoComponentPath.CreateFromHorizontalLine(model.feature_geometry)
  }, [model.feature_geometry])

  return (
    <>
      <SurfaceLineFeature3D
        path={path}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
    </>
  )
}
